// ToastContext.jsx
import { createContext, useContext, useState, useCallback } from 'react';

// Componentes
import Toast from '../components/Toast/Toast';

const ToastContext = createContext();

let toastIdCounter = 0;

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const showToast = useCallback((message, duration = 3000, type = 'default') => {
        const id = toastIdCounter++;
        setToasts(prev => [...prev, { id, message, duration, type }]);

        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, duration);
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <div style={{ position: 'fixed', bottom: '1.5rem', right: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', zIndex: 9999 }}>
                {toasts.map(toast => (
                    <Toast key={toast.id} message={toast.message} duration={toast.duration} type={toast.type} />
                ))}
            </div>
        </ToastContext.Provider>
    );
}

export function useToast() {
    return useContext(ToastContext);
}